import React, { useState } from "react";

import { OutlinedInput, Pagination } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AuthService from "../../Components/auth/AuthService";
import {
  useLoadingDispatch,
  showLoading,
  hideLoading,
} from "../../context/loadingContext";
import { DeleteFilled, EditFilled, PlusCircleFilled } from "@ant-design/icons";
import { Button, Flex, Input, Table } from "antd/es";
import Message from "../../Components/common/Message";


const Auth = new AuthService();

export default function UserList() {
  const navigate = useNavigate();
  var layoutDispatch = useLoadingDispatch();

  const [users, setUsers] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [page, setPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(0);
  const [limit] = React.useState(50);

  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("");

  const userColumn = [
    {
      title: 'First Name',
      dataIndex: 'first_name',
      key: 'first_name',
    },
    {
      title: 'Last Name',
      dataIndex: 'last_name',
      key: 'last_name',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
   
    
    {
      title: 'Action',
      key: 'action',
      align: "right",
      dataIndex: '',
      render(record) {
        return (
          <div onClick={(e) => e.stopPropagation()}>
            <EditFilled onClick={() => handleRowClick(record.id)} style={{ fontSize: '25px', cursor: "pointer", marginRight: "5px", color: "#001529" }} />
          </div>
        );
      },
    },
  ];


  React.useEffect(() => {
    showLoading(layoutDispatch);
    Auth.post(`/user/users`, {
      limit: limit,
      page: page,
      searchText: searchText?.trim(),
    })
      .then((res) => {
        hideLoading(layoutDispatch);
        if (res.ack) {
          setUsers(res.users);
          setTotalPages(Math.ceil(res.total_count / limit));
        } else {
          setType("error");
          setLoadMessage(res.message);
        }
      })
      .catch((err) => {
        hideLoading(layoutDispatch);
        setLoadMessage("error");
      });
  }, [page]);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleRowClick = (id) => {
    navigate(`/user/${id}`)
  };

  const Search = () => {
    showLoading(layoutDispatch);
    Auth.post(`/user/users`, {
      limit: limit,
      page: 1,
      searchText: searchText?.trim(),
    })
      .then((res) => {
        hideLoading(layoutDispatch);
        if (res.ack) {
          setUsers(res.users);
          setTotalPages(Math.ceil(res.total_count / limit));
        } else {
          setType("error");
          setLoadMessage(res.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };

  return (
    <div>
      <div >
        <div >
          <Input
            id="searchText"
            name="searchText"
            value={searchText}
            onChange={handleSearch}
            placeholder="Search"
            style={{ width: "300px", marginRight: "10px" }}
          />
          <Button
            type="primary"
            onClick={Search}
          >
            Search
          </Button>
        </div>
        <Flex justify='end'>
          <PlusCircleFilled style={{ fontSize: "30px", color: "#006cb8" }} onClick={() => navigate("/user/new")} />
        </Flex >
      </div>
      <div >
      <Table
        dataSource={users}
        style={{ overflowX: "auto" }}
        columns={userColumn}
        pagination={false}
        footer={() => `List of Users - Total Records: ${users.length === 0 ? "0" : users.length}`}
        rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
        scroll={{x:'max-content'}}
      />
      </div>
      <div style={{ float: "right", margin: "10px" }}>
        <Pagination
          page={page}
          count={totalPages}
          variant="outlined"
          color="primary"
          onChange={handleChange}
        />
      </div>
      
      <Message type={type} msg={loadMessage} />
    </div>
  );
}
